module.exports = __webpack_public_path__ + "img/pistol.m92.0299038a.png";